
<template>
  <v-form ref="form" lazy-validation>
    <v-text-field v-model="company.name" :readonly="read_only" :rules="required" 
     label="Nome" prepend-icon="mdi-domain"></v-text-field>
    <v-text-field v-model="company.fantasyName" :readonly="read_only" :rules="required"
     label="Nome Fantasia" prepend-icon="mdi-domain"></v-text-field>
    <v-text-field v-model="company.corporateName" :readonly="read_only" :rules="required"
     label="Nome Corporativo" prepend-icon="mdi-domain"></v-text-field>
    <v-text-field v-model="company.CNPJ" :readonly="read_only" :rules="[...required,...cnpj_rules]" 
     label="CNPJ" v-mask="'##.###.###/####-##'" prepend-icon="mdi-text-box"></v-text-field>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'
export default {
  name: 'CompanyForm',
  mixins:[validations],
  data() {
    return {
      model_form: false,
      cnpj_rules: [
        v => !!v || 'Campo é obrigatório',
        v => v && v.length == 18 || 'CNPJ deve ser completo',
        v => v && this.validarCNPJ(v) || 'CNPJ inválido'
      ],
    }
  },
  props:{
    company:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },

  },
}
</script>

<style scoped>

</style>